import getScrollingContainer from '@/utils/getScrollingContainer'

/**
 * This function brings the element into focus inside the immediate parent scrolling container
 * @param element
 */

export default element => {
  const scrollingContainer = getScrollingContainer(element)
  if (!scrollingContainer) return
  const { offsetHeight, scrollTop } = scrollingContainer
  const rect = element.getBoundingClientRect()
  const scrollingContainerRect = scrollingContainer.getBoundingClientRect()
  const relativeRect = {}
  // relativeRect is the rect relative to scrollingContainer. This is specially required for the cases when scrollingContainer is somewhere
  // in between the viewport like dropdown, popovers
  relativeRect.top = rect.top - scrollingContainerRect.top
  relativeRect.bottom = rect.bottom - scrollingContainerRect.top
  if (relativeRect.top + rect.height > offsetHeight) {
    let newScrollTop = scrollTop + relativeRect.bottom - offsetHeight
    if (newScrollTop - scrollTop < relativeRect.top) {
      // difference of previous and current scrollPosition should not be greater than top of element,
      // else on scroll element top will go out of the viewport
      scrollingContainer.scrollTo({
        top: scrollTop + relativeRect.bottom - offsetHeight,
        behavior: 'smooth'
      })
    } else {
      if (relativeRect.top > offsetHeight) {
        // if element is outside of viewport
        element.scrollIntoView()
      }
    }
  } else if (relativeRect.top < 0) {
    scrollingContainer.scrollTo({ top: scrollTop + relativeRect.top, behavior: 'smooth' })
  }
}
